import React, { useState, useEffect } from 'react';
import './index.css';
import FileUpload from 'components/file-upload';
import PreviewImg from 'components/preview-image';
import uploadImage from 'images/upload.png';
import { useMediaQuery } from 'react-responsive';
import { isMintproApp, urlToFile } from '__utils/common-utils';
import { getAgentCode } from '__utils/storage';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import { fetchPost, get, getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import resolveURLParams from '__utils/url-params-resolver';
import cameraIcon from 'images/cameraIcon.svg';
import UploadIconFile from 'images/uploadIconFile.svg';

export const showKnowMoreRegister = () => {
    Mixpanel.track(getEventName('IamInterested', 'clicked', 'home'))
    // Make Zendesk api call on I am Interested button click

    post(resolveURLParams(ENDPOINTS.CREATE_LEAD, { tag: 'mf_interested' }, null), { customParams: null }, getDefaultHeaders(), true)
        .subscribe((response: AjaxResponse | AjaxError) => {
        }, (error: AjaxError) => {
        });
};

interface ImageProps {
    showImageSlabFor: string;
    onUploadCallBack: Function;
    arnCode?: any;
    arnImageUploadFailure?: Function;
    onCancelClick: Function,
    disabled?: boolean
}
export const ArnNismImageSlab: React.FC<ImageProps> = ({ showImageSlabFor, onUploadCallBack, onCancelClick, arnCode, arnImageUploadFailure, disabled=false }) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const [isNISMSubmitted, setIsNISMSubmitted] = useState<boolean>(false);
    const [isARNImgSubmitted, setIsARNImgSubmitted] = useState<boolean>(false);
    const [NISMimgUrl, setNISMimgUrl] = useState<string>('');
    const [ARNimgUrl, setARNimgUrl] = useState<string>('');
    const NISMuploadUrl = `${ENDPOINTS.POST_UPLOAD_NISM_CERTIFICATE_PIC}/${getAgentCode()}`;
    const ARNuploadUrl = `${ENDPOINTS.POST_UPLOAD_ARN_CERTIFICATE_PIC}/${getAgentCode()}/ARN-${arnCode}`;

    useEffect(() => {
        getPreviwCertificates(showImageSlabFor === 'NISM' ? ENDPOINTS.GET_PREVIEW_NISM_CERTIFICATE : ENDPOINTS.GET_PREVIEW_ARN_CERTIFICATE)
    }, [showImageSlabFor])

    //show preview of the image uploaded
    const proceedAfterImgUpload = (url: string) => {
        if (showImageSlabFor === 'NISM') uploadNISM(url);
        else uploadARN(url);
    }

    const getPreviwCertificates = (endpoint: any) => {
        get(endpoint + `/${getAgentCode()}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.value) {
                    proceedAfterImgUpload(response?.response?.value);
                }
            }, (error: AjaxError) => {
                console.error(error);
            });
    }

    //upload NISM certificate
    const uploadNISM = (imgUrl: string) => {
        setIsNISMSubmitted(true);
        setNISMimgUrl(imgUrl);
        onUploadCallBack(showImageSlabFor, imgUrl);
    }

    //upload ARN certificate
    const uploadARN = (imgUrl: string) => {
        if (imgUrl === 'Agent Certificate Registration Failed. ARN Code is already mapped to other agent') {
            arnImageUploadFailure && arnImageUploadFailure();
        } else {
            setIsARNImgSubmitted(true);
            setARNimgUrl(imgUrl);
            onUploadCallBack(showImageSlabFor, imgUrl);
        }
    }

    //Executed When click picture button is clicked
    const clickPictureBtn = () => {
        if ((window as any).mpFeatures && (window as any).mpFeatures.permissions === true) {
            var featurePayload = {
                type: 'permissions',
                payload: {
                    permissionType: 'camera',
                    customEventName: showImageSlabFor === 'NISM' ? 'captureNismImage' : 'captureArnImage'
                },
            };
            window.postMessage(JSON.stringify(featurePayload), '*');
        }
        if (showImageSlabFor === 'NISM') window.addEventListener("captureNismImage", uploadImgFromApp);
        else window.addEventListener("captureArnImage", uploadImgFromApp);
        document.removeEventListener('captureNismImage', () => { });
        document.removeEventListener('captureArnImage', () => { });
    }

    //upload file after clicking picture in mintpro app
    const uploadImageFile = (file: any) => {
        const uploadEndP = showImageSlabFor === 'NISM' ? NISMuploadUrl : ARNuploadUrl;
        if (file) {
            if (!(file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp') || file.size > 5000000) {
                flash.error("Invalid file. You can upload jpeg/jpg/png/bmp/gif file of < 5mb size.");
            }
            else {
                const formData = new FormData();
                formData.append('file', file);
                fetchPost(uploadEndP, formData, null, true
                ).then((response: any) => {
                    if (response.value) {
                        flash.success("File uploaded successfully.");
                        proceedAfterImgUpload(response?.value);
                    }
                    else {
                        flash.error("Failed to upload. Please try again later.");
                    }
                }).catch((error: any) => {
                    flash.error("Failed to upload. Please try again later.");
                })
            }
        }
    }

    const uploadImgFromApp = (value: any) => {
        const uploadedImage = urlToFile(value.detail.data, value.detail.fileName);
        uploadedImage.then((result) => {
            uploadImageFile(result);
        })

    }

    //When x btn on preview is clicked again show fileupload div
    const onCancelPreview = () => {
        if (showImageSlabFor === 'NISM') {
            setNISMimgUrl('');
            setIsNISMSubmitted(false);
        }
        else {
            setARNimgUrl('');
            setIsARNImgSubmitted(false);
        }
        onCancelClick(showImageSlabFor);
    }

    //When x btn on file-upload is clicked again show update div
    const onCancelUpdateDiv = () => {
        if (showImageSlabFor === 'NISM') setIsNISMSubmitted(true);
        else setIsARNImgSubmitted(true);

    }

    //common Fileupload Div
    const certificateUpdateDiv = () => {
        return <div className={isMobile ? 'iconToUpload' : 'labelForFileInput'}>
            <div className={isMobile ? 'iconPreviewBg' : ''}>
                <img src={isMobile ? UploadIconFile : uploadImage} alt="upload"></img>
            </div>
            <p className='uploadLabel'>Upload File</p>
        </div>
    }

    return <>
        {showImageSlabFor === 'NISM' ? <>
            <div className='mt16 mb16'>
                <p>{isMobile ? 'Take a picture or upload your NISM certificate' : 'Upload your NISM certificate'}</p>
                <div className='grid-center'>
                    {NISMimgUrl && <PreviewImg
                        id={"uploadNISMFile"}
                        imgUrl={NISMimgUrl}
                        style={{ height: '78px', width: '108px' }}
                        showUpdateDiv={!isMobile && isNISMSubmitted}
                        cancelBtn={isMobile && <div className='cancelBtn' onClick={onCancelPreview}>X</div>}
                        updateDiv={<div className='updateDiv'>Update</div>}
                        onUpdateClick={() => setIsNISMSubmitted(false)}
                        disabled={disabled}
                    />
                    }
                    {isMintproApp() && <FileUpload
                        name="nismPicUpload"
                        className='uploadImgCls'
                        id="uploadNISMCamera"
                        accept='image/*'
                        noFileType
                        onClick={clickPictureBtn}
                        isUploaded={isNISMSubmitted}
                        style={{ marginTop: '8px' }}
                    >
                        <div className='iconToUpload'>
                            <div className='iconPreviewBg'>
                                <img src={cameraIcon} alt="upload"></img>
                            </div>
                            <p className='uploadLabel'>Click Picture</p>
                        </div>
                    </FileUpload>}
                    <div className={isMobile ? '' : 'posR'}>

                        <FileUpload
                            name="nismUpload"
                            className='uploadImgCls'
                            id="uploadNISMFile"
                            accept='image/*'
                            isUploaded={isNISMSubmitted}
                            style={{ marginTop: '8px' }}
                            uploadURL={NISMuploadUrl}
                            uploadCallBack={uploadNISM}
                        >
                            {certificateUpdateDiv()}
                        </FileUpload>
                        {!isMobile && (NISMimgUrl && !isNISMSubmitted) && <div className='upload-cancel' onClick={() => onCancelUpdateDiv()}>X</div>}
                    </div>
                </div>

            </div>

        </> : <>
            <div className='mt16 mb16'>
                <p>{isMobile ? 'Take a picture or upload your ARN certificate' : 'Upload your ARN certificate'}</p>
                <div className='grid-center'>
                    {ARNimgUrl &&
                        <PreviewImg
                            id="uploadARN"
                            imgUrl={ARNimgUrl}
                            style={{ height: '78px', width: '108px' }}
                            showUpdateDiv={!isMobile && isARNImgSubmitted}
                            cancelBtn={isMobile && <div className='cancelBtn' onClick={onCancelPreview}>X</div>}
                            updateDiv={
                                <div className='updateDiv'>Update</div>
                            }
                            onUpdateClick={() => setIsARNImgSubmitted(false)}
                            disabled={disabled}
                        />
                    }
                    {isMintproApp() && <FileUpload
                        name="arnUpload"
                        className='uploadImgCls'
                        id='clickARNpic'
                        accept='image/*'
                        noFileType
                        isUploaded={isARNImgSubmitted}
                        style={{ marginTop: '8px' }}
                        onClick={clickPictureBtn}
                    >
                        <div className='iconToUpload'>
                            <div className='iconPreviewBg'>
                                <img src={cameraIcon} alt="upload"></img>
                            </div>
                            <p className='uploadLabel'>Click Picture</p>
                        </div>
                    </FileUpload>}
                    <div className='posR'>
                        <FileUpload
                            name="arnUpload"
                            className='uploadImgCls'
                            id='uploadARNPic'
                            accept='image/*'
                            isUploaded={isARNImgSubmitted}
                            style={{ marginTop: '8px' }}
                            uploadURL={ARNuploadUrl}
                            uploadCallBack={uploadARN}
                        >
                            {certificateUpdateDiv()}
                        </FileUpload>
                        {!isMobile && (ARNimgUrl && !isARNImgSubmitted) && <div className='upload-cancel' onClick={() => onCancelUpdateDiv()}>X</div>}
                    </div>
                </div>

            </div>
        </>}


    </>
};








